import { HelpContentContainer } from ".";
import { ModalHeader } from "@/components/Modal/ModalHeader";
import { AppText } from "@/components/Text/AppText";

interface HelpGuideEditingResumeProps {
    onClose: () => void;
    setActiveNavItem: (item: string) => void;
}

export const HelpGuideEditingResume = ({
    onClose,
    setActiveNavItem,
}: HelpGuideEditingResumeProps) => {
    return (
        <div>
            <ModalHeader
                title="Editing your Resume"
                onClose={onClose}
            />
            <HelpContentContainer>
                <AppText
                    variant="regular"
                    className="mb-2"
                >
                    Once you have entered into the Resume Builder, simply click
                    on the text you wish to modify and begin typing to make
                    changes.
                </AppText>
                <AppText
                    variant="regular"
                    className="mb-2"
                >
                    You can also format the style of the text by highlighting
                    the text you wish to format and selecting one of the icons
                    (bold, italics, underline, or hyperlink) in the toolbar at
                    the top of the screen.
                </AppText>
                <AppText
                    variant="regular"
                    className="mb-2"
                >
                    A full list of hotkeys can be found{" "}
                    <span
                        className="cursor-pointer"
                        onClick={() => setActiveNavItem("hotkeys")}
                    >
                        <strong>here</strong>
                    </span>
                    .
                </AppText>
            </HelpContentContainer>
        </div>
    );
};
